import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Setting, SubscriptionsService } from '../services/user/subscriptions.service';
import { SettingsService } from '../services/user/settings.service';
import { TokenPropertyService } from '../services/token-property.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsComponent implements OnInit {
  userSettingsForm: FormGroup;
  emailId: string = '';

  constructor(
    private fb: FormBuilder, 
    private subscriptionsService: SubscriptionsService, 
    private router: Router,
    private settingsService: SettingsService,
    private tokenPropertyService: TokenPropertyService
  ) {
    const initSettings: Setting = { emailId: '', notificationInd: false };
    this.userSettingsForm = this.fb.group(initSettings);
  }

  ngOnInit() {
    // Get emailId from token as fallback
    const tokenEmailId = this.tokenPropertyService.getPropertyFromToken('custom:emailId') || '';
    this.emailId = tokenEmailId;
    
    this.userSettingsForm.get('emailId')?.setValue(this.emailId);
    this.userSettingsForm.get('emailId')?.disable();
    
    this.subscriptionsService.getUserSettings().subscribe((data: any) => {
      if (data != null && data.length > 0) {
        const firstSetting: Setting = data[0];

        if (firstSetting.notificationInd == "Y") {
          firstSetting.notificationInd = true;
        } else {
          firstSetting.notificationInd = false;
        }
        
        // Use emailId from API if available, otherwise keep token value
        const emailToUse = firstSetting.emailId || this.emailId;
        this.emailId = emailToUse;
        
        this.userSettingsForm.patchValue({
          emailId: emailToUse,
          notificationInd: firstSetting.notificationInd
        });
      }
    });
    // Make sure to disable the email field again
    this.userSettingsForm.get('emailId')?.disable();
  }

  onSubmit(): void {
    // Use getRawValue() to include disabled form fields, then override emailId to be safe
    const userSettings: any = this.userSettingsForm.getRawValue();
    
    // Convert boolean to Y/N string format
    if (userSettings.notificationInd == true) {
      userSettings.notificationInd = 'Y'
    } else {
      userSettings.notificationInd = 'N';
    }
    
    // Ensure emailId is set from our stored value (in case form value is empty)
    if (!userSettings.emailId || userSettings.emailId.trim() === '') {
      userSettings.emailId = this.emailId;
    }
    
    this.subscriptionsService.createUpdateUserSetting(userSettings).subscribe({
      next: (response) => {
        // Clear the settings cache so next call fetches fresh data
        this.settingsService.clearCache();
      },
      error: (error) => {
        console.error("Error updating settings:", error);
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/home']);
  }

}
